import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-q-all-comparison',
  templateUrl: './q-all-comparison.component.html',
  styleUrls: ['./q-all-comparison.component.scss']
})
export class QAllComparisonComponent implements OnInit {
  @Input() data: any;

  q2Data: any = null;
  q3Data: any = null;
  q4Data: any = null;

  ngOnInit(): void {
    if (this.data) {
      this.q2Data = Object.keys(this.data.q2).reduce((acc, key) => {
        acc[key] = {
          value: this.data.q2[key],
          color: 'gray'
        };
        return acc;
      }, {} as { [key: string]: { value: number; color: string } });

      this.q3Data = Object.keys(this.data.q3).reduce((acc, key) => {
        acc[key] = {
          value: this.data.q3[key],
          color: 'gray'
        };
        return acc;
      }, {} as { [key: string]: { value: number; color: string } });

      this.q4Data = Object.keys(this.data.q4).reduce((acc, key) => {
        const prevValue = this.data.q3[key];
        const nextValue = this.data.q4[key];
        let color = 'gray';
  
        // Determine color based on comparison
        const isQuality = key === 'quality';
        
        if (prevValue < nextValue) {
          color = isQuality ? 'red' : 'green';
        } else if (prevValue > nextValue) {
          color = isQuality ? 'green' : 'red';
        }
  
        acc[key] = {
          value: nextValue,
          color: color
        };
        return acc;
      }, {} as { [key: string]: { value: number; color: string } });
    }
  }
}
